import { useMemo } from 'react'
import { z } from 'zod'
import { StatusBadge } from './StatusBadge'

const DataWithMessage = z.object({ message: z.string().optional().nullable() }).optional()

export function MutationSuccessMessage(props: {
	mutation: { data?: unknown; isSuccess: boolean }
}) {
	const message = useMemo(() => {
		if (props.mutation.isSuccess) {
			const data = DataWithMessage.safeParse(props.mutation.data)
			if (data.success) {
				return (
					<StatusBadge
						status="published"
						label={data.data?.message ?? 'Password changed successfully'}
					/>
				)
			}
		}
		return null
	}, [props.mutation.data, props.mutation.isSuccess])

	return message
}
